import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=30d07a86&"
import script from "./Badge.vue?vue&type=script&lang=js&"
export * from "./Badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/toshiya.murasaki/Docker/Laravel/TRIPLE-CROWN/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d07a86')) {
      api.createRecord('30d07a86', component.options)
    } else {
      api.reload('30d07a86', component.options)
    }
    module.hot.accept("./Badge.vue?vue&type=template&id=30d07a86&", function () {
      api.rerender('30d07a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/common/Atoms/Badge.vue"
export default component.exports